module.exports = __webpack_public_path__ + "static/media/test5_1.c76af1c0.png";